import {
  ActionButton,
  Dialog,
  DialogCloseX,
  DialogHeading,
  DialogContent,
  DialogButtons,
  DialogButton,
  DialogTrigger,
} from "@tandemdiabetes/sugarmate-react-components"
import type { MouseEventHandler } from "react"
import { useCallback } from "react"

import { usePolyglot } from "src/contexts"
import { useSignOut } from "src/hooks"

const polyglotPrefix = "pages.account.account_details.log_out."

export function LogOut() {
  const polyglot = usePolyglot()
  const signOut = useSignOut()

  const onSignOutClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    () => {
      void signOut?.()
    },
    [signOut],
  )

  return (
    <Dialog>
      <DialogTrigger asChild>
        <ActionButton
          stylePreset="secondary"
          id="log-out-button"
        >
          {polyglot.t(`${polyglotPrefix}trigger_cta`)}
        </ActionButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}title`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogButtons>
          <DialogButton
            stylePreset="destructive"
            id="confirm-logout"
            onClick={onSignOutClick}
            disabled={!signOut}
          >
            {polyglot.t(`${polyglotPrefix}confirm_cta`)}
          </DialogButton>
          <DialogButton>
            {polyglot.t(`${polyglotPrefix}cancel_cta`)}
          </DialogButton>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}
